<app-base-template (modal)="openModal(content)" (tabledata)="getTableData()" [displayData]="displayData"
  [nextOffset]="nextOffset" [previousOffset]="previousOffset" (offset)="getData($event)"
  (pageSize)="onPageSizeChange($event)" [pageNo]="page_no" [totalPage]="totalPage" [dataLoaded]="dataLoaded">
</app-base-template>
<ng-template #content let-c="close" let-d="dismiss">
  <div class="modal-header modalTitle">
    <div class="modal-title">Add Auto Ticket Configuration..</div>

  </div>
  <div class="modal-body">
    <div class="loader" [hidden]="dataLoaded"><img class="loading-gif" src="../../../assets/img/loader.gif"></div>
    <div class="none" [ngClass]="{'inputError':isError}">{{errorMessage}}</div>
    <div class="none" [ngClass]="{'inputError':isError1}">{{errorMessage}}</div>

    <div class="form-group">
      <select class="custom-select mr-sm-2 radius-0 font-13" [(ngModel)]="ticketSelected"
        (change)="onTicketChange($event.target.selectedIndex)">
        <option *ngFor="let ticket of ttypes" [value]="ticket.id">{{ticket.name}}</option>
      </select>
    </div>

    <!-- <div class="form-group">
      <select class="custom-select mr-sm-2 radius-0 font-13" [(ngModel)]="groupSelected"
        (change)="onSupportGroupChange($event.target.selectedIndex)">
        <option *ngFor="let group of support_group" [value]="group.id">{{group.name}}</option>
      </select>
    </div> -->

    <div class="row">
      <div class="col-md-12 pad-15 category">
        <div class="height-40" [hidden]="categoryLoaded">
          <img class="loading-gif-42" src="../../../assets/img/loader-42px.gif">
        </div>
        <select class="custom-select  tcktyp" *ngFor="let ticket of ticketTypes;" [disabled]="ticket.isDisabled"
          (change)="onCategoryChange(ticket,$event.target.value)" id="ticket_{{ticket.id}}" [hidden]="!categoryLoaded">
          <option *ngFor="let option of ticket.options" [value]="option|json">{{option.title}}</option>
        </select>
      </div>
    </div>

    <div class=" mar-lft-rgt-0">
      <div class="row" style=" margin-left: 15px;">
        <div class="margin" *ngFor="let field of dynamicFields;" [ngSwitch]="field.fieldType">
          <input [ngClass]="field.isQuestion? ' ' : 'col-sm-12'" *ngSwitchCase="'1'" [hidden]="field.isQuestion"
            type="text" class="form-control radius-0 font-13 marginTop" placeholder="{{field.fieldName}}"
            [(ngModel)]="field.value">
          <mat-form-field *ngSwitchCase="'4'" class="col-sm-2 matcss">
            <mat-label>{{field.fieldName}}</mat-label>
            <mat-select [(ngModel)]="field.value">
              <mat-option *ngFor="let opt of field.values" [value]="opt">{{opt}}</mat-option>
            </mat-select>
          </mat-form-field>
          <div class="form-group  marginTop" *ngSwitchCase="'1'" [hidden]="!field.isQuestion">
            <div class="row margin2">

              <label class="col-sm-7 col-form-label label1 ">{{field.fieldName}}</label>
              <div class="col-sm-5">
                <div class="form-group">
                  <input type="text" class="form-control radius-0 font-13 " [(ngModel)]="field.value"
                    (keypress)="blockSpecialChar($event)" maxlength="200" />
                </div>
              </div>

            </div>
          </div>
          <div class="form-group  marginTop" *ngSwitchCase="'7'" [hidden]="!field.isQuestion">
            <div class="row margin2">

              <label class="col-sm-7 col-form-label label1 ">{{field.fieldName}}</label>
              <div class="col-sm-5">
                <div class="form-group">
                  <textarea class="form-control radius-0 font-13 " [(ngModel)]="field.value"
                    (keypress)="blockSpecialChar($event)" maxlength="200"></textarea>
                </div>
              </div>

            </div>
          </div>
          <div class="form-group" *ngSwitchCase="'2'">
            <div class="row margin2 date-type">
              <div class="form-group">
                <input [hidden]="field.isQuestion" class="form-control radius-0 font-13 marginTop"
                  placeholder="{{field.fieldName}}" [(ngModel)]="field.value" [owlDateTimeTrigger]="dt"
                  [owlDateTime]="dt">
                <owl-date-time [pickerType]="'calendar'" #dt></owl-date-time>
              </div>
            </div>
          </div>
          <div class="form-group " *ngSwitchCase="'5'">
            <div class="row margin2 date-type">
              <div class="form-group">
                <input [hidden]="field.isQuestion" class="form-control radius-0 font-13 marginTop"
                  placeholder="{{field.fieldName}}" [(ngModel)]="field.value" [owlDateTimeTrigger]="dt"
                  [owlDateTime]="dt">
                <owl-date-time [pickerType]="'timer'" #dt></owl-date-time>
              </div>
            </div>
          </div>
          <div class="form-group " *ngSwitchCase="'6'">
            <div class="row margin2 date-type">
              <div class="form-group">
                <input [hidden]="field.isQuestion" class="form-control radius-0 font-13 marginTop"
                  placeholder="{{field.fieldName}}" [(ngModel)]="field.value" [owlDateTimeTrigger]="dt"
                  [owlDateTime]="dt">
                <owl-date-time #dt></owl-date-time>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>

    <div class="form-group" *ngIf="groupLevel !== 0">
      <select class="custom-select mr-sm-2 radius-0 font-13" [(ngModel)]="userSelected"
        (change)="onUserChange($event.target.selectedIndex)">
        <option *ngFor="let user of users" [value]="user.id">{{user.name}}</option>
      </select>
    </div>

    <div class="form-group row mar-lft-rgt-0" *ngIf="groupLevel == 0">
      <input class="form-control radius-0 font-13 col-sm-8" type="text" [(ngModel)]="userName"
        placeholder="Enter PS Number" (keydown.enter)="changeId($event)">

      <button type="button" class="btn btn-success radius-0 col-sm-2" style="margin-left: 50px;"
        (click)="changeId($event)">Get Requester Info</button>

    </div>

    <div class="form-group">
      <input type="text" class="form-control radius-0 font-13 "
        placeholder="Requester info (Ex. Name, phone number , email etc)" [(ngModel)]="name" title="{{name}}" readonly>
    </div>

    <div class="form-group">
      <input type="text" class="form-control radius-0 font-13" [(ngModel)]="ticketTitle" placeholder="Ticket title"
        maxlength="45">
    </div>

    <div class="form-group">
      <textarea class="form-control radius-0 font-13" [(ngModel)]="ticketDesc" placeholder="Ticket description"
        maxlength="190" required></textarea>
    </div>
    <div class="form-group">
      <select class="custom-select mr-sm-2 radius-0 font-13" [(ngModel)]="activitySelected"
        (change)="onActivityChange($event.target.selectedIndex)">
        <option *ngFor="let activity of activityType" [value]="activity.id">{{activity.activity}}</option>
      </select>
    </div>
    <!--[hidden] = "!showDaily"-->
    <div class="form-group" *ngFor="let val of activityValue; let in=index">
      <div *ngIf="activityTypeId === 1">
        <input class="form-control radius-0 font-13" [owlDateTimeTrigger]="dt8" [owlDateTime]="dt8"
          placeholder="Activity Value" [(ngModel)]="activityValue[in].value">
        <owl-date-time [pickerType]="'both'" #dt8></owl-date-time>
      </div>
      <div *ngIf="activityTypeId === 2">
        <input class="form-control radius-0 font-13" [owlDateTimeTrigger]="dt9" [owlDateTime]="dt9"
          placeholder="Activity Value" [(ngModel)]="activityValue[in].value">
        <owl-date-time [pickerType]="'timer'" #dt9></owl-date-time>
      </div>
    </div>
    <div *ngIf="activityTypeId === 3">
      <table class="table table-hover font-13 dayChecked">
        <tbody>
          <tr>
            <td>
              <mat-checkbox value="0" [(ngModel)]="sunChck">Sun</mat-checkbox>
            </td>
            <td *ngFor="let sun of sunValue; let in=index"><input class="form-control radius-0 font-13"
                [owlDateTimeTrigger]="dt1" [owlDateTime]="dt1" placeholder="Enter Time ..."
                [(ngModel)]="sunValue[in].value">
              <owl-date-time [pickerType]="'timer'" #dt1></owl-date-time>
            </td>
            <td><button (click)="addSunTime()">Add more</button></td>
          </tr>
          <tr>
            <td>
              <mat-checkbox value="1" [(ngModel)]="monChck">Mon</mat-checkbox>
            </td>
            <td *ngFor="let mon of monValue; let in=index"><input class="form-control radius-0 font-13"
                [owlDateTimeTrigger]="dt2" [owlDateTime]="dt2" placeholder="Enter Time ..."
                [(ngModel)]="monValue[in].value">
              <owl-date-time [pickerType]="'timer'" #dt2></owl-date-time>
            </td>
            <td><button (click)="addMonTime()">Add more</button></td>
          </tr>
          <tr>
            <td>
              <mat-checkbox value="2" [(ngModel)]="tueChck">Tue</mat-checkbox>
            </td>
            <td *ngFor="let tue of tueValue; let in=index"><input class="form-control radius-0 font-13"
                [owlDateTimeTrigger]="dt3" [owlDateTime]="dt3" placeholder="Enter Time ..."
                [(ngModel)]="tueValue[in].value">
              <owl-date-time [pickerType]="'timer'" #dt3></owl-date-time>
            </td>
            <td><button (click)="addTueTime()">Add more</button></td>
          </tr>
          <tr>
            <td>
              <mat-checkbox value="3" [(ngModel)]="wedChck">Wed</mat-checkbox>
            </td>
            <td *ngFor="let wed of wedValue; let in=index"><input class="form-control radius-0 font-13"
                [owlDateTimeTrigger]="dt4" [owlDateTime]="dt4" placeholder="Enter Time ..."
                [(ngModel)]="wedValue[in].value">
              <owl-date-time [pickerType]="'timer'" #dt4></owl-date-time>
            </td>
            <td><button (click)="addWedTime()">Add more</button></td>
          </tr>
          <tr>
            <td>
              <mat-checkbox value="4" [(ngModel)]="thurChck">Thurs</mat-checkbox>
            </td>
            <td *ngFor="let thu of thuValue; let in=index"><input class="form-control radius-0 font-13"
                [owlDateTimeTrigger]="dt5" [owlDateTime]="dt5" placeholder="Enter Time ..."
                [(ngModel)]="thuValue[in].value">
              <owl-date-time [pickerType]="'timer'" #dt5></owl-date-time>
            </td>
            <td><button (click)="addThuTime()">Add more</button></td>
          </tr>
          <tr>
            <td>
              <mat-checkbox value="5" [(ngModel)]="friChck">Fri</mat-checkbox>
            </td>
            <td *ngFor="let fri of friValue; let in=index"><input class="form-control radius-0 font-13"
                [owlDateTimeTrigger]="dt6" [owlDateTime]="dt6" placeholder="Enter Time ..."
                [(ngModel)]="friValue[in].value">
              <owl-date-time [pickerType]="'timer'" #dt6></owl-date-time>
            </td>
            <td><button (click)="addFriTime()">Add more</button></td>
          </tr>
          <tr>
            <td>
              <mat-checkbox value="6" [(ngModel)]="satChck">Sat</mat-checkbox>
            </td>
            <td *ngFor="let sat of satValue; let in=index"><input class="form-control radius-0 font-13"
                [owlDateTimeTrigger]="dt7" [owlDateTime]="dt7" placeholder="Enter Time ..."
                [(ngModel)]="satValue[in].value">
              <owl-date-time [pickerType]="'timer'" #dt7></owl-date-time>
            </td>
            <td><button (click)="satFriTime()">Add more</button></td>
          </tr>

        </tbody>
      </table>
    </div>
    <div *ngIf="activityTypeId === 4">
      <!--<div id="content">-->
      <div id="contentInside" *ngFor="let container of monthlyActivity;">
        <div class="row">
          <div class="col-sm-4">
            <div class="form-group">
              <select class="custom-select mr-sm-2 radius-0 font-13" [(ngModel)]="container.month">
                <option *ngFor="let month of allMonths" [value]="month.name">{{month.name}}</option>
              </select>
            </div>
          </div>
          <div class="col-sm-4">
            <div class="row">
              <div class="col-sm-4">
                <label>Select Date:</label>
              </div>
              <div class="col-sm-8">
                <select class="custom-select mr-sm-2 radius-0 font-13" [(ngModel)]="container.date">
                  <option *ngFor="let number of allDate" [ngValue]="number">{{number}}</option>
                </select>
              </div>
            </div>
          </div>
          <div class="col-sm-4">
            <input class="form-control radius-0 font-13" [owlDateTimeTrigger]="dt10" [owlDateTime]="dt10"
              placeholder="Activity Value" [(ngModel)]="container.time">
            <owl-date-time [pickerType]="'timer'" #dt10></owl-date-time>
          </div>
        </div>
      </div>
      <button (click)="addMonthlyActivityDiv()">Add more</button>
      <!--</div>-->
    </div>
    <div *ngIf="activityTypeId === 5">
      <div>
        <div *ngFor="let container of quarterlyActivity; let i = index;">
          <div class="row">
            <div class="col-sm-2">
              <div class="form-group">
                <select class="custom-select mr-sm-2 radius-0 font-13" [id]="'Q'+i" [(ngModel)]="container.quarter"
                  (change)="onQuarterChange($event.target.selectedIndex,i)">
                  <option *ngFor="let quarter of allQuarter" [value]="quarter.name">{{quarter.name}}</option>
                </select>
              </div>
            </div>

            <div class="col-sm-2">
              <div class="form-group">
                <select class="custom-select mr-sm-2 radius-0 font-13" [id]="'M'+i" [(ngModel)]="container.month">
                  <!-- <option *ngFor="let month of quarterlyMonth" [value]="month.name">{{month.name}}</option> -->
                </select>

                <!-- <option *ngFor="let month of quarterlyMonth2" [value]="month.name">{{month.name}}</option>
                  <option *ngFor="let month of quarterlyMonth3" [value]="month.name">{{month.name}}</option>
                  <option *ngFor="let month of quarterlyMonth4" [value]="month.name">{{month.name}}</option> -->

              </div>
            </div>

            <!-- <div class="col-sm-3">
              <div class="form-group">
                <select class="custom-select mr-sm-2 radius-0 font-13" [(ngModel)]="container.day">
                  <option *ngFor="let day of allDays" [value]="day.name">{{day.name}}</option>
                </select>
              </div>
            </div> -->

            <div class="col-sm-4">
              <div class="row">
                <div class="col-sm-4">
                  <label>Select Date:</label>
                </div>
                <div class="col-sm-8">
                  <select class="custom-select mr-sm-2 radius-0 font-13" [(ngModel)]="container.date">
                    <option *ngFor="let number of allDate" [ngValue]="number">{{number}}</option>
                  </select>
                </div>
              </div>
            </div>

            <div class="col-sm-2">
              <input class="form-control radius-0 font-13" [owlDateTimeTrigger]="dt10" [owlDateTime]="dt10"
                placeholder="Activity Value" [(ngModel)]="container.time">
              <owl-date-time [pickerType]="'timer'" #dt10></owl-date-time>
            </div>
          </div>
        </div>
        <button (click)="addQuarterlyActivityDiv()">Add more</button>
      </div>
    </div>
  </div>
  <div class="modal-footer pad-8">
    <button type="button" class="btn btn-success radius-0" (click)="save()">Save</button>
    <button type="button" class="btn btn-danger radius-0" (click)="c()">Cancel</button>
  </div>
</ng-template>



<ng-template #openActivityValueDetail>
  <div class="modal-header  color">
    <h4 class="modal-title" id="modal-basic-title">Schedule Details</h4>
    <!-- <button type="button" class="close" aria-label="Close" (click)="modal.dismiss('Cross click')">
    <span aria-hidden="true">&times;</span>
    </button> -->
  </div>
  <div class="modal-body">


    <form class="form-horizontal">
      <div class="form-group">
        <div class="row">
          <label class="control-label col-sm-3 bold">Ticket Type:</label>
          <div class="col-sm-9">
            <textarea class="form-control" [value]="itemValue.ticketType" readonly></textarea>
          </div>
        </div>
      </div>
      <div class="form-group">
        <div class="row">
          <label class="control-label col-sm-3 bold">Ticket category:</label>
          <div class="col-sm-9">
            <textarea class="form-control" [value]="itemValue.category" readonly></textarea>
          </div>
        </div>
      </div>
      <div class="form-group">
        <div class="row">
          <label class="control-label col-sm-3 bold">Ticket Title:</label>
          <div class="col-sm-9">
            <textarea class="form-control" [value]="itemValue.ticket_title" readonly></textarea>
          </div>
        </div>
      </div>

      <div class="form-group">
        <div class="row">
          <label class="control-label col-sm-3 bold">Ticket Description:</label>
          <div class="col-sm-9">
            <textarea class="form-control" [value]="itemValue.ticket_description" readonly></textarea>
          </div>
        </div>
      </div>
      <div class="form-group">
        <div class="row">
          <label class="control-label col-sm-3 bold" for="email">Activity type:</label>
          <div class="col-sm-9">
            <textarea class="form-control" [value]="itemValue.activity_type" readonly></textarea>
          </div>
        </div>
      </div>
    </form>
    <!-- <p class="marginLft">Activity type :{{itemValue.activity_type}}</p> -->
    <!-- <p class="marginLft">Ticket Type :{{itemValue.ticketType}}</p>
   <p class="marginLft">Ticket category :{{itemValue.category}}</p> 
   <p class="marginLft">Ticket Title :{{itemValue.ticket_title}}</p>
   <p class="marginLft">Ticket Description :{{itemValue.ticket_description}}</p> -->


    <div class="backColor">
      <div class="adhoc " [hidden]="!adhocLoad">
        <p *ngFor="let values of value2;">{{values}}</p>
      </div>
      <div class="daily" [hidden]="!dailyLoad">
        <p *ngFor="let values of value2;">{{values}}</p>
      </div>

      <div class="row weekly paddinglft" [hidden]="!weeklyLoad">
        <div class="col-sm-3">
          <div class="row inline" *ngFor="let values of value3;">
            <label class="label bold">Day:</label>
            <p>{{values}}</p>
          </div>
        </div>
        <div class="col-sm-8">
          <div class="row inline" *ngFor="let value of value4;">
            <label class="label bold">Time:</label>
            <p>{{value}}</p>
          </div>
        </div>
      </div>

      <div class=" row monthly paddinglft" *ngFor="let values of value5;" [hidden]="!monthlyLoad">
        <div class="col-sm-4">
          <div class="inline ">
            <label class="bold">Month:</label>
            <p> {{values.month}}</p>
          </div>
        </div>

        <div class="col-sm-4">
          <div class="inline">
            <label class="bold">Date:</label>
            <p> {{values.date}}</p>
          </div>

        </div>
        <div class="col-sm-4">
          <div class="inline">
            <label class="bold">Time:</label>
            <p> {{values.time}}</p>
          </div>
        </div>
      </div>



      <div *ngFor="let values of value6;" [hidden]="!quarterlyLoad">
        <div class="inline mrginlft">
          <label class="bold">Quarter:</label>
          <p> {{values.quarter}}</p>
        </div>
        <div class=" row Quarterly paddinglft ">
          <div class="col-sm-4">
            <div class="inline">
              <label>Month:</label>
              <p> {{values.month}}</p>
            </div>
          </div>

          <div class="col-sm-4">
            <div class="inline">
              <label>Date:</label>
              <p> {{values.date}}</p>
            </div>

          </div>
          <div class="col-sm-4">
            <div class="inline">
              <label>Time:</label>
              <p> {{values.time}}</p>
            </div>
          </div>

        </div>

      </div>
      <!-- ngfor -->




    </div>
    <!-- backColor -->



  </div>

  <div class="modal-footer pad-8">
    <button type="button" class="btn btn-danger radius-0" (click)="c()">Close</button>
  </div>

</ng-template>


<notifier-container></notifier-container>